import { useCallback, useMemo } from "react"
import PropTypes from "prop-types"
import ListItemDropDown from "components/list-item-dropdown"
import GraphTemplateSelector from "connected-components/graph/components/template-selector"
import GraphPanelPeriodControl from "connected-components/graph/components/panel-period-control"
import { MODEL_METADATA_SHAPE } from "connected-components/asset-view/prop-types"
import { INSTRUMENTS_WITH_METADATA_SHAPE } from "connected-components/asset-view/prop-types"
import { buildModelCategoryOptions } from "connected-components/graph/helpers"
import { useCategorySync } from "connected-components/graph/hooks/use-category-sync"
import { useGraphTemplateChart } from "../../hooks/use-graph-template-chart"
import { GRAPH_PERFORMANCE_TEMPLATE_KEY, GRAPH_CATEGORY_DEFAULTS } from "../template-chart-config"
const BASIC_CATEGORIES = [
  { id: "total", primaryText: "Total" },
  { id: "factors", primaryText: "Factors" },
]

export default function GraphHeader({ modelMetadata, duplicateViewButton }) {
  const { selectedCategory, setSelectedCategory, isPreferencesLoaded } = useGraphTemplateChart(
    GRAPH_PERFORMANCE_TEMPLATE_KEY,
    GRAPH_CATEGORY_DEFAULTS,
  )

  const categoryOptions = useMemo(
    () => buildModelCategoryOptions(modelMetadata, BASIC_CATEGORIES),
    [modelMetadata],
  )

  useCategorySync(categoryOptions, selectedCategory, setSelectedCategory, isPreferencesLoaded)

  const handleCategoryChange = useCallback((category) => {
    setSelectedCategory(category)
  }, [setSelectedCategory])

  return (
    <>
      <GraphTemplateSelector />
      <GraphPanelPeriodControl />
      <ListItemDropDown
        label="Category"
        value={selectedCategory}
        setValue={handleCategoryChange}
        options={categoryOptions}
        alignMenu="left"
        disablePortal
      />
      {duplicateViewButton && <div className="graph-header-right">{duplicateViewButton}</div>}
    </>
  )
}

GraphHeader.propTypes = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
  instrumentsWithMetadata: INSTRUMENTS_WITH_METADATA_SHAPE.isRequired,
  duplicateViewButton: PropTypes.node,
}
